import { createUseStyles } from 'react-jss';
import { backgrounds } from '../../utils/theme';

export default createUseStyles({
  box: {
    border: `1px solid ${backgrounds.bg1}`,
  },
});
